<template>
  <div class="card">
    <div class="head">
      <h3>
        答题卡
        <span>(共{{ allNum }}题)</span>
      </h3>
      <div class="head_right">
        <p v-for="(item, index) in circleList" :key="index">
          <span class="base_circle smal_circle" :class="`bg_${item.color}`"></span>
          <span>{{ item.txt }}</span>
        </p>
      </div>
    </div>
    <div class="content">
      <div style="margin-top: 20px;" v-for="(item, index) in list" :key="index">
        <template v-if="item.num">
          <h3>
            {{ item.typeName }}
            <span>(共{{ item.num }}题)</span>
          </h3>
          <div class="box_list">
            <p
              v-for="(it, i) in parseInt(item.num)"
              :key="index + '-' + it"
              @click="click(index, i)"
              class="box base_circle circle"
              :class="circleColor(item, i)"
            >
              {{ it }}
            </p>
            <p style="width: 30px;margin-right: 28px;" v-for="i in 4" :key="i + '-'"></p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    done: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    circleList() {
      if (this.done) {
        return [
          {
            txt: '正确',
            color: 'green'
          },
          {
            txt: '错误',
            color: 'red'
          },
          {
            txt: '未做',
            color: 'grey'
          }
        ]
      } else {
        return [
          {
            txt: '已做',
            color: 'blue'
          },
          {
            txt: '未做',
            color: 'grey'
          }
        ]
      }
    },
    allNum() {
      if (!this.list.length) return 0
      return this.list.reduce((sum, value) => {
        return sum + parseInt(value.num)
      }, 0)
    },
    circleColor() {
      const colors = { Y: 'bg_green', N: 'bg_red', E: '' }
      return function(data, index) {
        const type = data.result[index].isRight || 'E'
        if (!this.done) {
          return data.list[index].myOption.length ? 'bg_blue' : ''
        }
        return colors[type]
      }
    }
  },
  methods: {
    click(i1, i2) {
      this.$emit('onAnchor', `#${i1}-${i2}`)
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
.head_right {
  display: flex;
  color: #5e668d;
  p {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
}
.content {
  .box_list {
    width: calc(100% + 28px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .box {
      margin-top: 10px;
      cursor: pointer;
      border: 1px solid #dcdfe6;
    }
    .box--active {
      border: none;
    }
  }
}
</style>
